export default __webpack_public_path__ + "static/media/file-format-pdf.0b3b6701.svg";